module.exports = __webpack_public_path__ + "static/Event-ce8ab6e14b3b0c18f1ef51ac85ab941e.jpg";